import { useQuery } from "@tanstack/react-query";
import api from "../../../api/api";
import { QUERY_ADMIN_DASHBOARD_EMPLOYEES_KEY } from "../../../api/queryKeys";
import { QueryAdminDashboardEmployeesResponse } from "../../../types";

interface Props {
  page: number;
}

export const getEmployeesData = (props: Props) =>
  api
    .get<QueryAdminDashboardEmployeesResponse>(
      QUERY_ADMIN_DASHBOARD_EMPLOYEES_KEY,
      { params: { page: props.page } }
    )
    .then((res) => res.data);

export default function useGetEmployees({ page = 1 }: { page: number }) {
  return useQuery([QUERY_ADMIN_DASHBOARD_EMPLOYEES_KEY, page], () =>
    getEmployeesData({ page })
  );
}
